
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(309|582|594|886)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
